import {
  IStockImageCropSize,
  StockImageAspectRatio,
} from '../interfaces/stock-image.interface';

export const STOCK_IMAGE_STRINGS = {
  NOT_CONFIGURED:
    'The photo library is not set up yet. Please contact support.',
  INVALID_KEY:
    'The photo library could not be reached. Please contact support.',
  RATE_LIMITED:
    'The photo library is busy right now. Please try again in a few minutes.',
  SEARCH_FAILED: 'We could not load photos right now. Please try again.',
  DOWNLOAD_FAILED:
    'We could not add that photo. Please try again or pick another one.',
};

export const STOCK_IMAGE_PAGE_SIZE = 75;

/** Results are cached per provider + query + page for the life of the tab. */
export const STOCK_IMAGE_CACHE_LIMIT = 60;

/**
 * How many downloaded photos are held on to. These are whole image files, so
 * the limit is small - it only exists to let a photo's download start when it
 * is selected and be finished by the time it is confirmed.
 */
export const STOCK_IMAGE_DOWNLOAD_LIMIT = 3;

/**
 * 'cover' is deliberately absent. A cover banner is 3:1, and a centre crop that
 * severe decapitates people often enough that the user has to frame it: the
 * photo is handed to the image cropper whole and cropped there instead.
 */
export const STOCK_IMAGE_CROP_SIZES: Partial<
  Record<StockImageAspectRatio, IStockImageCropSize>
> = {
  square: { width: 1200, height: 1200 },
  landscape: { width: 1400, height: 800 },
};

/**
 * Crop for the picker's result grid. Same ratios as above at tile size, so what
 * the user sees in the grid is the framing that actually gets saved.
 */
export const STOCK_IMAGE_TILE_CROP_SIZES: Partial<
  Record<StockImageAspectRatio, IStockImageCropSize>
> = {
  square: { width: 500, height: 500 },
  landscape: { width: 560, height: 320 },
};
